
import { Component, Prop } from "vue-property-decorator";
import { TypedVue } from "@/store/types";

// Wraps any inline element with the report's dark tooltip (same look and positioning
// as DiscussionFlag). Renders the slot untouched when `text` is empty.
@Component
export default class HoverTip extends TypedVue {
  @Prop({ default: "" }) text!: string;

  public visible = false;
  public placeBelow = false;
  public tipStyle: Record<string, string> = {};

  showTip(): void {
    if (!this.text) return;
    this.visible = true;
    // Wait for the tooltip to render so we can measure it before positioning.
    this.$nextTick(() => this.positionTip());
  }

  hideTip(): void {
    this.visible = false;
  }

  // Fixed positioning escapes the report's scroll/overflow containers, so the bubble
  // is placed against the viewport manually on each hover/focus.
  positionTip(): void {
    const tip = this.$refs.tip as HTMLElement | undefined;
    const el = this.$el as HTMLElement;
    if (!tip || !el) return;

    const margin = 8;
    const gap = 6;
    const anchor = el.getBoundingClientRect();
    const { width: tw, height: th } = tip.getBoundingClientRect();

    const anchorCenter = anchor.left + anchor.width / 2;
    let left = anchorCenter - tw / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - tw - margin));

    this.placeBelow = anchor.top - th - gap < margin;
    const top = this.placeBelow ? anchor.bottom + gap : anchor.top - th - gap;

    this.tipStyle = {
      left: `${Math.round(left)}px`,
      top: `${Math.round(top)}px`,
      "--arrow-left": `${Math.round(anchorCenter - left)}px`,
    };
  }
}
